var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8334 13.3334V16C25.8334 21.1547 21.6547 25.3334 16.5001 25.3334M7.16675 13.3334V16C7.16675 21.1547 11.3454 25.3334 16.5001 25.3334M16.5001 25.3334V29.3334M11.1667 29.3334H21.8334M16.5001 20C14.2909 20 12.5001 18.2092 12.5001 16V6.66669C12.5001 4.45755 14.2909 2.66669 16.5001 2.66669C18.7092 2.66669 20.5001 4.45755 20.5001 6.66669V16C20.5001 18.2092 18.7092 20 16.5001 20Z",
    stroke: "#11113A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicro);
export default __webpack_public_path__ + "static/media/micro.ea54c2f331a9b986ba067231d1aa4123.svg";
export { ForwardRef as ReactComponent };